import { Injectable } from '@angular/core';
import { IControlSubRoutes } from '../models/models';
import { DynamicControlSubRoutes } from '../../device-model/dynamic-control-sub-routes';
import { RtuControlSubRoutes } from '../../device-model/rtu-control-sub-routes';

@Injectable({
    providedIn: 'root'
})
export class ControlSubRouteFactoryService {
    public static $name = 'controlSubRouteFactory';

    public getSubroutes(hardwareCategory: string): IControlSubRoutes {
        switch (hardwareCategory) {
            case 'rtu':
                return new RtuControlSubRoutes();

            default:
                return new DynamicControlSubRoutes();
        }
    }
}
